import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "./store"

export const selectTachos = (state: RootState) => state.tachos

export const selectAccountHasTacho = (state: RootState) =>
  Object.keys(state.tachos).length > 0

export const selectTacho = (jid: string | undefined) => {
  return createSelector(selectTachos, (tachos) =>
    jid ? tachos[jid] : undefined,
  )
}
